export { toMiraklCategoryId } from './categoryId';
export { MIRAKL_BEACON_PATHS, MIRAKL_PAGE } from './constants';
// Browser-safe: the consent rule depends only on the GDPR cookie helpers, so browser code can use
// it without the /server entry, which brings in token verification and Node crypto.
export { decideMiraklConsent } from './server/consent';
export { MIRAKL_USER_ID_COOKIE } from './server/constants';
export type { MiraklPageId } from './constants';
export type {
  ClickBeaconBody,
  MiraklAdUnit,
  MiraklLine,
  MiraklListingIdentity,
  MiraklProductId,
  ViewBeaconBody,
} from './types';
